import httpService from "@/utils/services/http_service";
import enums from "@/utils/enums";
import localData from "@/utils/utils/localData";

export default {
  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async areaList(data = {}) {
    // 如果是查全部的
    let isQueryAll = data.pagesize && data.pagesize == enums.allPageSize
    console.log(isQueryAll)
    let localAreaList = localData.getLocalAreaList(data)
    if (isQueryAll  && localAreaList) {
      return {
        list: localAreaList
      }
    }

    let resData = await httpService.post(
      '/api.php?do=admin_area_list',
      data
    )
    if (isQueryAll && !data.area_type) {
      localData.setLocalAreaList(resData.list)
    }

    return resData
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async addArea(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async editArea(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_edit',
      data
    )
  },

   /**
   * @author: lafitewu
   * date: 2020-07-29
   *  地区库详情1.4
   */
  async InfoArea(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async deleteArea(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_delete',
      data
    )
  },

  // 1.4新增 lafitewu
  async statusArea(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_status_edit',
      data
    )
  },
  /**
   * @author: zhengyongbo
   * date: 2020-02-06
   *  管理员列表
   */
  async areaConfigList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_config_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  风险分类列表
   */
  async riskTypeList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_list',
      data
    )
  },

   /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  风险分类列表
   */
  async riskTypeInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  添加风险分类
   */
  async addRiskType(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  编辑风险分类
   */
  async editRiskType(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  删除风险分类
   */
  async deleteRiskType(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  模型列表
   */
  async modelList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_pattern_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  模型详情
   */
  async modelDetail(data = {}) {
    return httpService.post(
      '/api.php?do=admin_pattern_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  添加模型
   */
  async addModel(data = {}) {
    return httpService.post(
      '/api.php?do=admin_pattern_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  编辑模型
   */
  async editModel(data = {}) {
    return httpService.post(
      '/api.php?do=admin_pattern_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  删除模型
   */
  async deleteModel(data = {}) {
    return httpService.post(
      '/api.php?do=admin_pattern_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  模块列表
   */
  async modelItemList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_pattern_item_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  模块详情
   */
  async modelItemDetail(data = {}) {
    return httpService.post(
      '/api.php?do=admin_pattern_item_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  添加模块
   */
  async addModelItem(data = {}) {
    return httpService.post(
      '/api.php?do=admin_pattern_item_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  编辑模块
   */
  async editModelItem(data = {}) {
    return httpService.post(
      '/api.php?do=admin_pattern_item_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  删除模块
   */
  async deleteModelItem(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  模型主体列表
   */
  async modelMainList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  修改模型主体开启关闭状态
   */
  async modelMainStatusChange(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_disable',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  模型主体详情
   */
  async modelMainDetail(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  添加模型主体
   */
  async addModelMain(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_set',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  删除模型主体
   */
  async deleteModelMain(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  模型主体加权项备选项列表
   */
  async modelMainFieldList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_item_field_option_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  添加模型主体加权项备选项
   */
  async addModelMainField(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_item_field_option_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  添加模型主体加权项备选项
   */
  async editModelMainField(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_item_field_option_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  删除模型主体加权项备选项
   */
  async deleteModelMainField(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_item_field_option_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-20
   *  重大事件节假日列表
   */
  async festivalList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_festival_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-20
   *  重大事件节假日详情
   */
  async festivalDetail(data = {}) {
    return httpService.post(
      '/api.php?do=admin_festival_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-20
   *  添加重大事件节假日
   */
  async addFestival(data = {}) {
    return httpService.post(
      '/api.php?do=admin_festival_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-20
   *  编辑重大事件节假日
   */
  async editFestival(data = {}) {
    return httpService.post(
      '/api.php?do=admin_festival_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-20
   *  删除重大事件节假日
   */
  async deleteFestival(data = {}) {
    return httpService.post(
      '/api.php?do=admin_festival_delete',
      data
    )
  },


  /**
   * @author: zhengyongbo
   * date: 2020-02-28
   *  (国家配置管理)模型风险默认值详情
   */
  async areaRiskConfigDetail(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_risk_field_default_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-28
   *  添加(国家配置管理)模型风险默认值
   */
  async addAreaRiskConfig(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_risk_field_default_set',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-28
   *  (国家配置管理)参考因素值列表
   */
  async areaRiskFieldList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_risk_field_option_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-28
   *  (国家配置管理)参考因素值详情
   */
  async areaRiskFieldDetail(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_risk_field_option_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-28
   *  添加(国家配置管理)参考因素值
   */
  async addAreaRiskField(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_risk_field_option_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-28
   *  编辑(国家配置管理)参考因素值
   */
  async editAreaRiskField(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_risk_field_option_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-28
   *  删除(国家配置管理)参考因素值
   */
  async deleteAreaRiskField(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_risk_field_option_delete',
      data
    )
  },

  /**
   * @author: lafitewu
   * date: 2020-04-17
   *  删除(国家配置管理)参考因素值
   */
  async adminAreaCopy(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_copy',
      data
    )
  },

  /**
   * @author: lafitewu
   * date: 2020-04-22
   *  模型管理-模型配置-干预配置
   */
  async addModelIntervene(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_pattern_score_overwrite_set',
      data
    )
  },

  // 2020.6.10新增 一键配置
  async configInit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_risk_field_config_init',
      data
    )
  },
}
